export default __webpack_public_path__ + "dist/media/Section 4.26dd90bc.png";